module.exports = __webpack_public_path__ + "img/20180815_145537_016.fa53675a.jpg";